import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export class CommonButton {
    title: string;
    url?: string;
    type?: 'button' | 'link';
    fill?: 'outline' | 'solid' | 'solidOutline' | 'none';
    preText?: string;
    subText?: string;
    icon?: string;
    iconType?: 'svg' | 'default';
    iconPosition?: 'left' | 'right';
    background?: 'primary' | 'white' | 'separator';
    textColor?: 'black' | 'white';
    disabled?: boolean;
    menu?: {
        options:
        {
            id: string;
            title: string;
        }[];
        selectedOption: {
            id: string;
            title: string;
        };
    } | null;
    constructor(button: CommonButton) {
        this.title = button.title || null;
        this.url = button.url || null;
        this.type = button.type || 'link';
        this.fill = button.fill || 'solid';
        this.preText = button.preText || null;
        this.subText = button.subText || null;
        this.icon = button.icon || null;
        this.iconType = button.iconType || 'default';
        this.iconPosition = button.iconPosition || 'right';
        this.background = button.background || 'primary';
        this.textColor = button.textColor || 'black';
        this.disabled = button.disabled || false;
        if (button.menu === undefined) {
            this.menu = null;
        } else {
            this.menu = button.menu;
        }
    }
}

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
    private _config: CommonButton;
    @Input() set config(config: CommonButton) {
        this._config = new CommonButton(config);
        if (this._config.menu) {
            this.type = `${this._config.type}-menu`;
        } else {
            this.type = this._config.type;
        }
    }
    get config() {
        return this._config;
    }
    @Output() menuOptionClick = new EventEmitter();
    type: string = null;
    @Output() public click: EventEmitter<MouseEvent> = new EventEmitter();
    constructor() { }

    onButtonClick(event: MouseEvent) {
        event.stopPropagation();
        if (this.config.disabled) {
            event.stopPropagation();
        } else {
            this.click.emit(event);
        }
    }

    ngOnInit() { }
}
